module.exports = __webpack_public_path__ + "img/logo.cc5e8fec.png";